import { render, staticRenderFns } from "./DoctorNotes.vue?vue&type=template&id=f8e3df44&scoped=true&"
import script from "./DoctorNotes.vue?vue&type=script&lang=js&"
export * from "./DoctorNotes.vue?vue&type=script&lang=js&"
import style0 from "./DoctorNotes.vue?vue&type=style&index=0&id=f8e3df44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e3df44",
  null
  
)

export default component.exports